module.exports = __webpack_public_path__ + "img/case-studies.d51d28f1.png";